import {NgModule} from '@angular/core';
import {CheckValidityDirective} from './check-validity.directive';
import {ValidationMessageDirective} from './validation-message.directive';
import {ValidatorService} from './validators/validator.service';
import {MarkRequiredDirective} from './mark-required.directive';
import {FormValidationService} from './form-validation.service';
import {CheckChangeValidityDirective} from './check-change-validity.directive';
import {NumericDirective} from './numeric.directive';

@NgModule({
    declarations: [
        CheckValidityDirective,
        ValidationMessageDirective,
        MarkRequiredDirective,
        CheckChangeValidityDirective,
        NumericDirective
    ],
    exports: [
        CheckValidityDirective,
        ValidationMessageDirective,
        MarkRequiredDirective,
        CheckChangeValidityDirective,
        NumericDirective
    ],
    providers: [
        ValidatorService,
        FormValidationService
    ]
})
export class ValidationModule {
}
